export const isFundMode = (value) => value === "cuota_igual" || value === "colecta" || value === "distintos";
export const fundModeExplainStepId = (mode) => {
    if (mode === "cuota_igual")
        return "explain-mode-same";
    if (mode === "colecta")
        return "explain-mode-colecta";
    return "explain-mode-distintos";
};
